import { css } from 'styled-components';

export const ActionWrapperBackgroundMixin = (isTopHeader?: boolean) => css`
	background: ${isTopHeader ? 'linear-gradient(98deg, #22293d 0%, #11192e 100%)' : '#f6f5f2'};
	backdrop-filter: ${isTopHeader ? 'blur(4px)' : 'none'};
`;
